import React, { useEffect, useRef } from "react";

interface AdScriptComponentProps {
  content: string;
}

const AdScriptComponent: React.FC<AdScriptComponentProps> = ({ content }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const uniqueId = React.useMemo(() => `ad-container-${Math.random().toString(36).substr(2, 9)}`, []);

  useEffect(() => {
    if (!containerRef.current || !content) return;

    // Clear existing content
    containerRef.current.innerHTML = "";

    // Create a range to parse the HTML string
    const range = document.createRange();
    const fragment = range.createContextualFragment(content);

    // Manually handle scripts to ensure they execute
    const scripts = Array.from(fragment.querySelectorAll("script"));
    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode?.replaceChild(newScript, oldScript);
    });

    containerRef.current.appendChild(fragment);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, [content]);

  return <div id={uniqueId} ref={containerRef} />;
};

export default AdScriptComponent;
